import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { InvestMediaportalMarketQuotationsDesktop } from '@alfa-bank/site-invest-mediaportal-market-quotations/widgets/desktop';
import { InvestMediaportalHeadlinesDesktop } from '@alfa-bank/site-invest-mediaportal-headlines/widgets/desktop';

import type { IMainHeaderProps } from '../models';
import { OverviewArticleDesktop } from '../../overview-article/desktop/component';

import styles from './styles.css';

export const MainHeaderDesktop: FC<IMainHeaderProps> = ({
    analytics,
    articleLabelText,
    articles,
    baseUrlToArticle,
    className,
    overviewArticle,
    quotationAssets,
}) => {
    return (
        <Block
            className={cn(className, styles.external, styles.wrapper)}
            notPadded
            styler={{ padding: 72 }}
        >
            <Grid
                className={cn(styles.external, styles.overview)}
                collapse
                columnsWidth={[752, 24, 364]}
                styler={{ marginBottom: 24 }}
            >
                <OverviewArticleDesktop
                    analytics={analytics}
                    article={overviewArticle}
                    articleLabelText={articleLabelText}
                    baseUrlToArticle={baseUrlToArticle}
                />
                <></>
                <InvestMediaportalMarketQuotationsDesktop assets={quotationAssets} />
            </Grid>
            <InvestMediaportalHeadlinesDesktop
                articles={articles}
                baseUrlToArticle={baseUrlToArticle}
                className={cn(styles.external, styles.headlines)}
            />
        </Block>
    );
};
